import { EmailTemplatesBackendAdapter, MailContentTemplate } from '../types';
import { useTemplateDynamicData } from './useTemplateDynamicData';
import { useTemplates } from './useTemplates';
import { useUpdateTemplate } from './useUpdateTemplate';
import { useBuildEmailTemplatePreview } from './useBuildEmailTemplatePreview';
import { useDeleteTemplate } from './useDeleteTemplate';

export const defaultEmailTemplateBackendAdapter = ({
  apiBaseUrl,
  employerId,
}: {
  apiBaseUrl: string;
  employerId: string;
}): EmailTemplatesBackendAdapter => {
  return {
    useEmailTemplates: ({ emailType }) =>
      useTemplates<MailContentTemplate>({ apiBaseUrl, employerId, templateType: 'email', templateName: emailType }),
    useUpdateEmailTemplate: ({ emailType, onTemplateUpdated }) =>
      useUpdateTemplate({
        apiBaseUrl,
        employerId,
        templateType: 'email',
        templateName: emailType,
        onTemplateUpdated,
      }),
    useBuildEmailTemplatePreview: ({ emailType }) =>
      useBuildEmailTemplatePreview({
        apiBaseUrl,
        employerId,
        emailType,
      }),
    useDeleteEmailTemplate: ({ emailType, onTemplateDeleted }) =>
      useDeleteTemplate({
        apiBaseUrl,
        employerId,
        templateType: 'email',
        templateName: emailType,
        onTemplateDeleted,
      }),
    useEmailTemplateDynamicData: ({ emailType }) =>
      useTemplateDynamicData({ apiBaseUrl, employerId, templateType: 'email', templateName: emailType }),
  };
};
